export default __webpack_public_path__ + "1386d99dc4308dbfe78613e024778b5d.png";